<template>
  <b-container fluid class="landing-wrapper">
    <vue-headful v-bind:title="$t('landing.metatitle')" v-bind:description="$t('landing.metadescription')" />

    <div id="main-banner" :class="il8n && il8n.local == 'en' ? 'en-main' : 'fr-main'">
      <a class="anchor" id="home"></a>

      <b-container>
        <div class="mainbg">
          <b-row class="header-col" data-aos="fade-right">
            <!-- <b-col class="header-col"> -->
            <h1 v-html="$t('landing.headline')"></h1>
            <h2 v-html="$t('landing.subheadline')"></h2>

            <div class="headercontent">
              <b-button :to="'/' + $router.currentRoute.params.lang + '/start'" class="mmm-button"
                >{{ $t("landing.beginbutton") }}
                <hr class="mmm-bar main-gradient"/>
                <hr class="white-bar"
              /></b-button>

              <a class="termslink" v-b-modal.terms v-html="$t('landing.clickterms')"></a>
              <p v-html="$t('landing.disclaimer')"></p>
            </div>
            <!-- </b-col> -->
          </b-row>
        </div>
      </b-container>
    </div>

    <b-container class="wrapper">
      <div class="lowerHeadMesh"></div>

      <!-- View Eligible Products -->
      <section class="eligibleproducts">
        <a class="anchor" id="products"></a>
        <b-container>
          <div class="productbg">
            <h2 data-aos="fade-right" v-html="$t('landing.productheadline')"></h2>
            <div class="headercontent">
              <button :class="'mmm-button'" v-html="$t('landing.productbutton') + `<hr class='mmm-bar main-gradient'/><hr class='white-bar'/>`" v-b-modal.productsbox></button>

              <a class="pdfguide" v-bind:href="'/' + $t('landing.pdffile')">{{ $t("landing.download") }}</a>

              <b-modal id="productsbox" size="lg" centered scrollable v-bind:title="$t('landing.modelheadline')" ok-only :ok-title="$t('master.okay')" hide-header-close>
                <b-row>
                  <b-col col cols="12" class="product-col" v-for="product in products" v-bind:key="product.id" v-bind:value="product.id">
                    <b-card tag="article" class="mb-2">
                      <p class="card-text">
                        <b-row class="card-row">
                          <b-col col cols="4">
                            <img v-if="product.image_url" class="img-fluid product-img" v-bind:alt="il8n && il8n.local == 'en' ? product.description : product.description_fr" v-bind:src="api + '/api/images/' + product.image_url" />
                            <img v-else class="img-fluid product-img" src="../assets/noimage.svg" :alt="$t('master.noimage')" />
                          </b-col>
                          <b-col col cols="8">
                            <b-row>
                              <b-col col cols="12">
                                <p class="product" v-if="$router.currentRoute.params.lang == 'en'">
                                  Spend <strong>${{ product.redeemvalue }}</strong> of qualifying 3M abrasives purchased within 12 months to redeem and get a bonus <strong>{{ product.name }}</strong
                                  >.
                                </p>
                                <p class="product" v-if="$router.currentRoute.params.lang == 'fr'">
                                  Achetez <strong>{{ product.redeemvalue }} $</strong> d’abrasifs 3M admissibles dans les 12 mois pour échanger et obtenir en prime une <strong>{{ product.name_fr }}</strong
                                  >.
                                </p>
                                <p class="desc" v-if="$router.currentRoute.params.lang == 'en'">{{ product.description }}</p>
                                <p class="desc" v-else-if="$router.currentRoute.params.lang == 'fr'">{{ product.description_fr }}</p>
                              </b-col>
                              <b-row class="moreproductinfo">
                                <b-table-simple hover small caption-top responsive>
                                  <b-thead head-variant="dark">
                                    <b-tr>
                                      <b-th v-if="product.reward_options[0].model">{{ $t("certificate.model") }}</b-th>
                                      <b-th v-if="product.reward_options[0].diameter">{{ $t("certificate.diameter") }} </b-th>
                                      <b-th v-if="product.reward_options[0].orbit">{{ $t("certificate.orbit") }}</b-th>
                                      <b-th v-if="product.reward_options[0].discpad">{{ $t("certificate.discpad") }}</b-th>
                                      <b-th v-if="product.reward_options[0].motor">{{ $t("certificate.motor") }}</b-th>
                                      <b-th v-if="product.reward_options[0].rpm">{{ $t("certificate.rpm") }}</b-th>
                                    </b-tr>
                                  </b-thead>
                                  <b-tbody>
                                    <b-tr v-for="reward in product.reward_options" v-bind:key="reward.id" v-bind:value="reward.id">
                                      <b-td v-if="reward.model">{{ reward.model }}</b-td>
                                      <b-td v-if="reward.diameter">{{ reward.diameter }} <span v-if="i18n.locale == 'en'">in</span><span v-if="i18n.locale == 'fr'">po</span></b-td>
                                      <b-td v-if="reward.orbit">{{ reward.orbit }}</b-td>
                                      <b-td v-if="reward.discpad && i18n.locale == 'en'">{{ reward.discpad }}</b-td>
                                      <b-td v-if="reward.discpad && i18n.locale == 'fr'">{{ reward.discpad_fr }}</b-td>
                                      <b-td v-if="reward.motor">{{ reward.motor }} HP</b-td>
                                      <b-td v-if="reward.rpm">{{ reward.rpm }}</b-td>
                                    </b-tr>
                                  </b-tbody>
                                </b-table-simple>
                              </b-row>
                            </b-row>
                          </b-col>
                        </b-row>
                      </p>
                    </b-card>
                  </b-col>
                </b-row>
              </b-modal>
            </div>
          </div>
        </b-container>
      </section>

      <div class="lowerHeadMesh"></div>

      <!-- Calculator Estimator -->
      <section class="calculator">
        <a class="anchor" id="estimater"></a>
        <b-form>
          <b-container>
            <b-row class="justify-content-md-center calculatorhead">
              <b-row class="justify-content-center">
                <b-col cols="12" md="10" xl="8">
                  <h2 v-html="$t('landing.calculatorheadline')"></h2>
                  <p v-html="$t('landing.calculatordescription')"></p>
                  <b-table class="cmon" v-if="$router.currentRoute.params.lang == 'en' || $router.currentRoute.params.lang == 'en'" head-variant="dark" striped hover :items="items" :fields="fields"></b-table>
                  <b-table v-if="$router.currentRoute.params.lang == 'fr'" head-variant="dark" striped hover :items="items_fr" :fields="fields_fr"></b-table>
                  <p v-html="$t('landing.calculatordisclaimer')"></p>
                </b-col>
              </b-row>
            </b-row>
          </b-container>
        </b-form>
      </section>

      <!-- Footer Call To Action -->
      <section class="footercta">
        <b-container>
          <b-row class="justify-content-md-center">
            <b-col cols="12">
              <!-- <b-link class="pinLink" href="./start" type="button">
              Begin your trade-up now
            </b-link> -->

              <b-button :to="'/' + $router.currentRoute.params.lang + '/start'" class="mmm-button"
                >{{ $t("landing.beginbutton") }}
                <hr class="mmm-bar main-gradient"/>
                <hr class="white-bar"
              /></b-button>
            </b-col>
            <b-col cols="12">
              <!-- <a class="termslink">† Click to see full terms and conditions</a> -->
              <a class="termslink" v-b-modal.terms v-html="$t('landing.clickterms')"></a>
            </b-col>
            <b-col col md="7" lg="6">
              <p v-html="$t('landing.disclaimer')"></p>
            </b-col>
          </b-row>
        </b-container>
      </section>
    </b-container>
  </b-container>
</template>

<script>
import { getHeader } from "../headers.js";

export default {
  name: "hello",
  data() {
    return {
      num: 0,
      total: 0,
      product1: 0,
      il8n: "",
      product2: 0,
      product3: 0,
      product4: 0,
      product5: 0,
      product6: 0,
      searchparameters: {
        count: 12,
        selected: null,
        search: "",
        totalpage: null,
        currentPage: null,
        totalrow: null,
      },
      products: [],
      categories: [],
      fields: [
        {
          key: "tier",
          label: "Purchasing Tiers",
        },
        {
          key: "bucks",
          label: "Reward",
        },
      ],
      fields_fr: [
        {
          key: "tier",
          label: "Niveaux d’achats",
        },
        {
          key: "bucks",
          label: "Récompense",
        },
      ],
      items: [
        { tier: "$2,500 of qualifying 3M abrasives", bucks: "Redeem to get a bonus 3M Xtract™ Electric or Pneumatic Random Orbital Sander" },
        { tier: "$3,000 of qualifying 3M abrasives", bucks: "Redeem to get a bonus 3M™ File Belt Sander" },
        { tier: "$5,000 of qualifying 3M abrasives", bucks: "Redeem to get a bonus 3M™ Disc Sander or 3M Xtract™ Portable Dust Extractor or 3M™ Electric Angle Grinder" },
        { tier: "$6,500 of qualifying 3M abrasives", bucks: "Redeem to get a bonus 3M™ 1 HP Grinder" },
        { tier: "$10,000 of qualifying 3M abrasives", bucks: "Redeem to get a bonus 3M™ 1.5 HP Grinder" },
      ],
      items_fr: [
        { tier: "2 500 $ d’abrasifs 3M admissibles", bucks: "Échangez pour obtenir en prime une Ponceuse pneumatique ou électrique orbitale à mouvements aléatoires 3M Xtract🅪" },
        { tier: "3 000 $ d’abrasifs 3M admissibles", bucks: "Échangez pour obtenir en prime une Ponceuse à courroie abrasive 3M🅪" },
        { tier: "5 000 $ d’abrasifs 3M admissibles", bucks: "Échangez pour obtenir en prime une Ponceuse à disque 3M🅪 ou Extracteur de poussière mobile 64256 3M Xtract🅪 ou Meuleuse d’angle électrique 3MMC" },
        { tier: "6 500 $ d’abrasifs 3M admissibles", bucks: "Échangez pour obtenir en prime une Meuleuse 1 HP 3M🅪" },
        { tier: "10 000 $ d’abrasifs 3M admissibles", bucks: "Échangez pour obtenir en prime une Meuleuse 1,5 HP 3M🅪" },
      ],
    };
  },
  mounted() {
    // window.fbq('trackCustom', 'Landing Page');

    this.$root.$on("bv::modal::show", () => {
      // bvEvent <- Was a param
      // if(bvEvent.target.id == 'productsbox') {

      // }
      this.loadProducts();
    });
  },

  methods: {
    inc(property, amt, totalamt) {
      this[property] += amt;
      this.total += totalamt;
    },
    dec(property, amt, totalamt) {
      if (this[property] === 0) return;
      this[property] -= amt;
      this.total -= totalamt;
    },
    loadProducts: function() {
      let vm = this;
      let dom = this.api + "/api/receive-products";
      this.axios.get(dom, { headers: getHeader() }).then(function(response) {
        vm.products = response.data;
        console.log(response);
      });
    },
  },
  created() {
    this.axios.interceptors.request.use(
      (config) => {
        this.loaded = false;
        return config;
      },
      (error) => {
        this.loaded = true;
        return Promise.reject(error);
      },
    );
    this.axios.interceptors.response.use(
      (response) => {
        this.loaded = true;
        return response;
      },
      (error) => {
        this.loaded = true;
        return Promise.reject(error);
      },
    );
  },
  watch: {},
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/global.scss";

a.clickherelink {
  color: #047bfe;
}
p.desc {
  font-size: 0.8rem;
}
p.product strong {
  font-family: "3M-Bold";
}

p {
  text-align: left !important;
}

table.table.b-table.cmon.table-striped.table-hover,
table.table.b-table.table-striped.table-hover {
  text-align: left !important;
}
.pdfguide {
  padding-top: 30px;
  color: white;
  text-decoration: underline;
  font-size: 1.2rem;
}
</style>
